import { useState, useEffect, useContext } from 'react';
import DashboardContext from '../../../context/dashboard/DashboardContext';
import DashboardGetStarted from './DashboardGetStarted/DashboardGetStarted';
import SampleVoucherSection from './SampleVoucherSection/SampleVoucherSection';
import TravellerAppFeatures from './TravellerAppFeatures/TravellerAppFeatures';
import DashboardShowcase from './DashboardShowcase/DashboardShowcase';
import DashboardSkeleton from './DashboardSkeleton';
import PageContainer from '../../../components/layout/PageContainer';
import GuidedTour from '../../../components/tour/GuidedTour';

import dashboardData from '../../../data/dashboard/dashboardData.json';

const TOUR_STEPS = dashboardData.tourSteps || [];

const HomeContent = () => {
  const {
    stats,
    recentVouchers,
    agentProfile,
    loading,
    fetchDashboardData,
  } = useContext(DashboardContext);

  // Tour state
  const [showGuidedTour, setShowGuidedTour] = useState(false);
  const [tourStep, setTourStep] = useState(0);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  const handleTourStepChange = (newStepIndex) => {
    setTourStep(newStepIndex);
  };

  const handleStartTour = () => {
    setTourStep(0);
    setShowGuidedTour(true);
  };

  const handleCloseTour = () => {
    setShowGuidedTour(false);
  };

  if (loading) {
    return <DashboardSkeleton />;
  }

  return (
    <PageContainer className="pb-10">
      <DashboardGetStarted
        stats={stats}
        agentProfile={agentProfile}
        recentVouchers={recentVouchers}
        onStartTour={handleStartTour}
        isTourActive={showGuidedTour}
        tourStep={tourStep}
      />
      <SampleVoucherSection />
      <TravellerAppFeatures />
      <DashboardShowcase />

      {/* Guided Tour Walkthrough (v2) */}
      <GuidedTour
        isOpen={showGuidedTour}
        onClose={handleCloseTour}
        currentStep={tourStep}
        onStepChange={handleTourStepChange}
        steps={TOUR_STEPS}
      />
    </PageContainer>
  );
};

export default HomeContent;
